"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutHeader() {
  const headlineWords = [{
    text: "Crafting",
    italic: false
  }, {
    text: "digital",
    italic: false
  }, {
    text: "legacies",
    italic: false
  }, {
    text: "daily.",
    italic: true
  }];
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const {
    ref: introRef,
    isVisible: introVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const {
    ref: image1Ref,
    isVisible: image1Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: image2Ref,
    isVisible: image2Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return;
}